import {common_utils} from "../common/common_utils";
import {slots_utils} from "../../../untils/slots_utils";
import {slots_tool} from "./slots_tool";

function game_5014()
{

}

game_5014.odd_map  = {
  "A":[0,0,1,3,6],
  "B":[0,0,1,3,6],
  "C":[0,0,2,4,10],
  "D":[0,0,3,5,12],
  "E":[0,0,3,5,12],
  "F":[0,0,5,10,15],
  "G":[0,0,6,15,30],
  "H":[0,0,8,20,40],
  "I":[0,0,10,25,50],
};

game_5014.mul_array  = [
  [1,2,3,5],
  [2,4,6,10]
]


game_5014.mul = 20

game_5014.readDataValue = function(this1,data)
{
  this1.hasfree = true
  if(this1.hasfree)
  {
    this1.isfree = common_utils.isFreeTip(data)
  }
  this1.hasbonuswin = false
  this1.mapList = data.detail.map
  let winValueList = [];
  console.log("this1.mapList", this1.mapList)
  common_utils.readDataValue(this1,data);
  // 匹配下标
  let s = new slots_utils();
  this1.geValue = s.showSlotsWinLineTable(data.gameId, this1.mapList, 0, [4, 5, 5, 5, 4]).m_dict
  this1.winlines = {};
  this1.winlines["0"] = s.showSlotsWinLineInfoTable(data.gameId, this1.mapList, 0, [4, 5, 5, 5, 4]);

  console.log(this1.geValue, "geValue")
  this1.mapIndex = []
  this1.mapListDetail = []
  let winIndex = 0;
  if (Object.keys(this1.geValue).length != 0)
  {
      for (var i = 0; i < Object.keys(this1.geValue).length; i++)
      {
            var mapIndexTmp = Object.values(this1.geValue)[i].flat(Infinity)
            for (var j = 0; j < mapIndexTmp.length; j++)
            {
              this1.mapIndex.push(mapIndexTmp[j])
              //console.log(this1.mapIndex, "this1.mapIndex")
            }
            var detail = {}
            var lines = 1;
            var mapIndexFullTmp = Object.values(this1.geValue)[i]
            for (var j = 0; j < mapIndexFullTmp.length; j++)
            {
               lines = lines * mapIndexFullTmp[j].length
            }
            detail.key = Object.keys(this1.geValue)[i]
            detail.lines = lines
            detail.length = Object.values(this1.geValue)[i].length
            let mul_value = slots_tool.read_index_mul(game_5014.mul_array,winIndex,data.isFree);
            detail = slots_tool.winInfo(game_5014.odd_map,detail,mul_value);
            winValueList.push(detail.winValue);
            this1.mapListDetail.push(detail)

      }
     winIndex++;
  }

  this1.subMapList = []
  this1.subMapIndex = []
  this1.subMapListDetail = []
  if (data.detail.allRestocks && data.detail.allRestocks.length > 1)
  {
    for (var index = 0; index < data.detail.allRestocks.length - 1; index++)
    {
      var subMap = []
      var subIndex = []
      if (index == 0)
      {
        subMap = this1.mapList
        subIndex = this1.mapIndex
      }
      else
      {
        subMap = this1.subMapList[index - 1]
        subIndex = this1.subMapIndex[index - 1]
      }

      var colList = []
      var col_index = 0;
      for (var col = 0; col < 5; col++) {
        var colTmp = []
        var base_row = col == 0 || col == 4 ? 4 : 5
        for (var row = base_row - 1; row >= 0; row--)
        {
            if (!subIndex.some(item => item == (col_index + row)))
            {
                colTmp.push(subMap[col_index + row])
            }
            else
            {
              if(subMap[col_index + row].length >= 2) {
                  colTmp.push("W")
              }
            }
        }

        var colNew = data.detail.allRestocks[index + 1].restock[col].symbols
        if (colNew) {
          for (var i = 0; i < colNew.length; i++) {
            colTmp.push(colNew[i])
          }
        }

        col_index = col_index + base_row;
        colList.push(colTmp)
      }

      // console.log(colList, "colList")
      // console.log(subMap, "subMap")

      subMap = []
      for (var i = 0; i < 5; i++)
      {
        for (var j = colList[i].length - 1; j >= 0; j--)
        {
           subMap.push(colList[i][j])
        }
      }

      console.log(subMap, "subMap")

      var subIndexNew = []
      var detailList = []
      var geValueTmp = s.showSlotsWinLineTable(data.gameId, subMap, 0, [4, 5, 5, 5, 4]).m_dict
      slots_tool.pushSubMapLine(this1.winlines,slots_tool.getSubLineHeadName(index),s.showSlotsWinLineInfoTable(data.gameId, subMap, 0, [4, 5, 5, 5, 4]))
      //console.log(geValueTmp, "geValueTm[]")
      if (Object.keys(geValueTmp).length != 0)
      {
        for (var i = 0; i < Object.keys(geValueTmp).length; i++)
        {
          var mapIndexTmp = Object.values(geValueTmp)[i].flat(Infinity)

          for (var j = 0; j < mapIndexTmp.length; j++) {
            subIndexNew.push(mapIndexTmp[j])
          }

          var detail = {}
          var lines = 1;
          let  value_length = 1;
          var mapIndexFullTmp = Object.values(geValueTmp)[i]
          for (var j = 0; j < mapIndexFullTmp.length; j++)
          {
              lines = lines * mapIndexFullTmp[j].length
          }
          detail.key = Object.keys(geValueTmp)[i]
          detail.lines = lines
          detail.length  = Object.values(geValueTmp)[i].length
          let mul_value = slots_tool.read_index_mul(game_5014.mul_array,winIndex,data.isFree);
          detail = slots_tool.winInfo(game_5014.odd_map,detail,mul_value);
          winValueList.push(detail.winValue);
          detailList.push(detail)
        }
      }
      winIndex++;
      this1.subMapList.push(subMap)
      this1.subMapIndex.push(subIndexNew)
      this1.subMapListDetail.push(detailList)
    }
  }
  slots_tool.drawSlotLines(this1,this1.winlines)
  this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,game_5014.mul);
}




export {
  game_5014
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5014.js